import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { DataView } from "primereact/dataview";
import { Menu } from "primereact/menu";
import * as React from "react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCoreFacade } from "../../../../../../../core/facades/Core.facade";
import { CoreConstants } from "../../../../../../../core/models/constants/core.constants";
import { Layout } from "../../../../../../../core/models/enums/core.enums";
import { useUIFacade } from "../../../../../../../ui/facades/ui.facade";
import PrwcGlobalFilter from "../../../../../../../ui/widgets/custom/PrwcGlobalFilter";
import PrwcGridListLayoutButton from "../../../../../../../ui/widgets/custom/PrwcGridListLayoutButton";
import { useUsersFacade } from "../../facades/Users.facade";
import "./UserList.scss";

const UserList = (props: any) => {

  const { onEdit } = props;
  const { t } = useTranslation();
  const coreFacade = useCoreFacade();
  const usersFacade: any = useUsersFacade();
  const [globalSearch, setGlobalSearch] = useState("");
  const [layout, setLayout] = useState(usersFacade.getUserListLayout());
  const menuRef: any = useRef(null);
  let selectedRowData: any = null;
  const uiFacade = useUIFacade();

  const handleOnDelete = (rowData: any) => {
    uiFacade.showConfirmDeleteDialog(rowData, deleteUser);
  }

  const menuItems = [
    {
      label: t("generic.action.edit"),
      icon: "pi pi-pencil",
      command: () => {
        editUser(selectedRowData);
      },
    },
    {
      label: t("generic.action.delete"),
      icon: "pi pi pi-trash",
      command: () => {
        handleOnDelete(selectedRowData);
      },
    },
  ];

  const editUser = (rowData: any) => {
    console.log("edit user ---");
    console.log(rowData);
    onEdit(rowData);
  };

  const deleteUser = (rowData: any) => {
    console.log("delete user ---");
    console.log(rowData);
  };

  const users = [
    {
      id: 1,
      name: "Abc",
      user: {
        name: "Amit",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      status: "ACTIVE",
      type: "limited access member",
      lastActivity: "Dec 1",
    },
    {
      id: 2,
      user: {
        name: "Amit",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "dsfdsfs",
      status: "ACTIVE",
      type: "limited access member",
      lastActivity: "Dec 1",
    },
    {
      id: 3,
      user: {
        name: "Amit",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "sdfdsds",
      status: "ACTIVE",
      type: "limited access member",
      lastActivity: "Dec 1",
    },
    {
      id: 4,
      user: {
        name: "sdsdss",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "sdfds",
      status: "ACTIVE",
      type: "limited access member",
      lastActivity: "Dec 1",
    },
    {
      id: 5,
      user: {
        name: "sdfsfssd",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "sdfdsf",
      status: "ACTIVE",
      type: "limited access member",
      lastActivity: "Dec 1",
    },
    {
      id: 6,
      user: {
        name: "sdsassa",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "Abc",
      status: "ACTIVE",
      type: "limited access member",
      lastActivity: "Dec 1",
    },
    {
      id: 7,
      user: {
        name: "Amit",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "dsfdsfs",
      status: "ACTIVE",
      type: "limited access member",
      lastActivity: "Dec 1",
    },
    {
      id: 8,
      user: {
        name: "dfgfdgfd",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "sdfdsds",
      status: "INACTIVE",
      type: "limited access member",
      lastActivity: "Dec 16",
    },
    {
      id: 9,
      user: {
        name: "yjygjgjnh",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "sdfds",
      status: "ACTIVE",
      type: "limited access member",
      lastActivity: "Dec 15",
    },
    {
      id: 10,
      user: {
        name: "ytyutyuty",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "sdfdsf",
      status: "PENDING",
      type: "limited access member",
      lastActivity: "Dec 14",
    },
    {
      id: 11,
      user: {
        name: "ukuhkgujgh",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "sdfdsf",
      status: "PENDING",
      type: "limited access member",
      lastActivity: "Dec 11",
    },
    {
      id: 12,
      user: {
        name: "sdfdsfsdfsdfsd",
        firstName: "Amit",
        lastName: "Chaudhary",
        emailID: "amit@google.com",
        phoneNumber: "989797989778",
      },
      name: "sdfdsf",
      status: "INACTIVE",
      type: "limited access member",
      lastActivity: "Dec 12",
    },
  ];

  const getStatus = (statusKey: string) => {
    if (statusKey) {
      switch (statusKey) {
        case CoreConstants.Status.active.key:
          return (
            <div className="inline-block px-2 py-0.5 text-xs font-semibold text-green-500 border border-green-500 rounded-md ">
              {t(CoreConstants.Status.active.labelKey)}
            </div>
          );
        case CoreConstants.Status.inactive.key:
          return (
            <div className="inline-block px-2 py-0.5 text-xs font-semibold text-red-500 border border-red-500 rounded-md ">
              {t(CoreConstants.Status.inactive.labelKey)}
            </div>
          );
        case CoreConstants.Status.pending.key:
          return (
            <div className="inline-block px-2 py-0.5 text-xs font-semibold text-yellow-500 align-middle border border-yellow-500 rounded-md ">
              {t(CoreConstants.Status.pending.labelKey)}
            </div>
          );
      }
    }
  };

  const handleGlobalSearch = (value: string) => {
    setGlobalSearch(value);
  };

  const handleLayout = (tableLayout: any) => {
    setLayout(tableLayout);
    usersFacade.setUserListLayout(tableLayout);
  };

  const userBodyTemplate = (rowData: any) => {
    return (
      <>
      <div className="flex justify-between">
        <div className="flex items-center">
          <div className="flex items-center justify-center ml-2 mr-4 bg-gray-300 rounded-full lg:ml-0 w-14 h-14 lg:w-10 lg:h-10">
            <span className="font-semibold text-gray-700 text-md">
              {coreFacade.getInitialsOfFullName(
                rowData.user.firstName,
                rowData.user.lastName
              )}
            </span>
          </div>
          <div>
            <div onClick={() => editUser(rowData)} className="font-medium text-blue-700 cursor-pointer text-md">
              {coreFacade.getFullName(
                rowData.user.firstName,
                rowData.user.lastName
              )}
            </div>
            <div className="flex flex-col text-xs font-medium tracking-wide text-gray-400 lg:divide-x-2 lg:flex-row">
              <div className="mb-1 lg:pr-2 lg:mb-0">{rowData.user.emailID}</div>
              <div className="lg:pl-2">{rowData.user.phoneNumber}</div>
            </div>
          </div>
        </div>
        <div className="mr-2 lg:mr-0 lg:hidden">
          {actionTemplate(rowData)}
        </div>
        </div>
      </>
    );
  };

  const statusBodyTemplate = (rowData: any) => {
    return (
      <div>
        <span className="ml-20 text-sm font-semibold lg:hidden lg:ml-0">
          {t("users.label.status")}
        </span>
        <span className="mx-2 lg:hidden">-</span>
        <span>{getStatus(rowData.status)}</span>
      </div>
    );
  };

  const typeBodyTemplate = (rowData: any) => {
    return (
      <div>
        <span className="ml-20 text-sm font-semibold lg:hidden lg:ml-0">
          {t("users.label.type")}
        </span>
        <span className="mx-2 lg:hidden">-</span>
        <span className="text-sm">{rowData.type}</span>
      </div>
    );
  };

  const lastActivityBodyTemplate = (rowData: any) => {
    return (
      <div>
        <span className="ml-20 text-sm font-semibold lg:hidden lg:ml-0">
          {t("users.label.lastActivity")}
        </span>
        <span className="mx-2 lg:hidden">-</span>
        <span className="text-sm">{rowData.lastActivity}</span>
      </div>
    );
  };

  const gridTemplate = (rowData: any) => {
    return (
      rowData && (
        <div className=" p-col-12 p-sm-6 p-md-6 p-lg-4">
          <div className="w-auto p-4 m-1 border-2 rounded-md">
            <div className="flex justify-between">
              <div className="flex items-center">
                <div className="flex items-center justify-center ml-2 mr-4 bg-gray-300 rounded-full w-14 h-14">
                  <span className="text-xl font-semibold text-gray-700">
                    {coreFacade.getInitialsOfFullName(
                      rowData.user.firstName,
                      rowData.user.lastName
                    )}
                  </span>
                </div>
                <div>
                  <div onClick={() => editUser(rowData)} className="font-medium text-blue-700 cursor-pointer text-md">
                    {coreFacade.getFullName(
                      rowData.user.firstName,
                      rowData.user.lastName
                    )}
                  </div>
                  <div className="flex flex-col text-xs font-medium text-gray-400 tracking">
                    <div className="mb-1">{rowData.user.emailID}</div>
                    <div>{rowData.user.phoneNumber}</div>
                  </div>
                </div>
              </div>

              <div>{actionTemplate(rowData)}</div>
            </div>

            <div className="ml-20">
              <div className="flex my-2">
                <div className="mr-2 text-sm font-semibold">
                  {t("users.label.status")} -
                </div>
                <div className="text-sm">{getStatus(rowData.status)}</div>
              </div>

              <div className="flex my-2">
                <div className="mr-2 text-sm font-semibold">
                  {t("users.label.type")} -
                </div>
                <div className="text-sm">{rowData.type}</div>
              </div>

              <div className="flex my-2">
                <div className="mr-2 text-sm font-semibold">
                  {t("users.label.lastActivity")} -
                </div>
                <div className="text-sm">{rowData.lastActivity}</div>
              </div>
            </div>
          </div>
        </div>
      )
    );
  };

  const handleOnMenuClick = (event: any, rowData: any) => {
    if (menuRef && menuRef.current) {
      menuRef.current.toggle(event);
      selectedRowData = rowData;
    }
  };

  const actionTemplate = (rowData: any) => {
    return (
      <div className="flex ml-2 lg:ml-0">
        <i
          className="text-xs cursor-pointer pi pi-ellipsis-v"
          onClick={(event: any) => handleOnMenuClick(event, rowData)}
        ></i>
      </div>
    );
  };

  return (
    <div className="user-list">
      <Menu
        model={menuItems}
        popup
        ref={menuRef}
        className="w-32 user-list-action-menu"
      />
      <div>
        <div className="flex items-center w-full pb-2 mr-1 rounded-t-xl">
          <div className="flex-1">
            <PrwcGlobalFilter
              value={globalSearch}
              onChange={handleGlobalSearch}
              className="w-full h-10 rounded-lg"
            ></PrwcGlobalFilter>
          </div>
          <div className="w-auto ml-2">
            <PrwcGridListLayoutButton
              layout={layout}
              onChange={handleLayout}
            ></PrwcGridListLayoutButton>
          </div>
        </div>

        {layout === Layout.GRID ? (
          <div className="">
            <DataView
              value={users}
              layout={Layout.GRID}
              itemTemplate={gridTemplate}
              className=""
              paginator
              rows={CoreConstants.Data.grid.paginator.rows}
              rowsPerPageOptions={
                CoreConstants.Data.grid.paginator.rowsPerPageOptions
              }
            ></DataView>
          </div>
        ) : (
          <div className="w-full">
            <DataTable
              globalFilter={globalSearch}
              className="p-datatable-responsive"
              value={users}
              paginator
              rows={CoreConstants.Data.table.paginator.rows}
              rowsPerPageOptions={
                CoreConstants.Data.table.paginator.rowsPerPageOptions
              }
            >
              <Column
                field="name"
                header={t("users.label.user")}
                body={userBodyTemplate}
                sortable
              ></Column>
              <Column
                field="status"
                body={statusBodyTemplate}
                header={t("users.label.status")}
                sortable
              ></Column>
              <Column
                field="type"
                header="Type"
                body={typeBodyTemplate}
              ></Column>
              <Column
                field="lastActivity"
                header={t("users.label.lastActivity")}
                body={lastActivityBodyTemplate}
                sortable
              ></Column>
              <Column
                field="action"
                body={(props: any) => actionTemplate(props)}
                className="w-px text-xs "
              ></Column>
            </DataTable>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserList;
